import { render } from "./BaseAudio.vue?vue&type=template&id=1dd0aad5"
import script from "./BaseAudio.vue?vue&type=script&lang=js"
export * from "./BaseAudio.vue?vue&type=script&lang=js"

import "./BaseAudio.vue?vue&type=style&index=0&id=1dd0aad5&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__